import { use, useState } from 'react';

import type { ToggleButtonProps } from '@mui/material';
import { Popover, ToggleButton } from '@mui/material';
import type { Editor } from '@tiptap/core';
import { EmojiEmotionsOutlined } from '@mui/icons-material';
import { EmojiStyle } from 'emoji-picker-react';

import { EmojiPickerContext } from '../contexts/EmojiPickerContext';

interface Props extends Omit<ToggleButtonProps, 'value'> {
  editor: Editor;
}

export const EmojiButton = ({ editor, ...other }: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const EmojiPicker = use(EmojiPickerContext);

  const open = Boolean(anchorEl);
  const id = open ? 'emoji-popover' : undefined;

  return (
    <>
      <ToggleButton
        {...other}
        aria-describedby={id}
        value="emoji"
        selected={false}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        <EmojiEmotionsOutlined />
      </ToggleButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <EmojiPicker
          emojiStyle={EmojiStyle.NATIVE}
          onEmojiClick={(emoji) =>
            editor.chain().focus().insertContent(emoji.emoji).run()
          }
        />
      </Popover>
    </>
  );
};
